import { render, staticRenderFns } from "./CdnList.vue?vue&type=template&id=2dacd73a"
import script from "./CdnList.vue?vue&type=script&lang=js"
export * from "./CdnList.vue?vue&type=script&lang=js"
import style0 from "./CdnList.vue?vue&type=style&index=0&id=2dacd73a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports